import { render, staticRenderFns } from "./PouchDetail.vue?vue&type=template&id=50d52a02&scoped=true&"
import script from "./PouchDetail.vue?vue&type=script&lang=js&"
export * from "./PouchDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d52a02",
  null
  
)

export default component.exports